import React from 'react';
import { AvTooltip, Filter } from '@fabric-ui/components';
import { CaseSensitive } from '@fabric-ui/icons';
import { AvButton } from './AvButton';

interface Props {
  actualFilterValue: Filter;
  filter: Filter;
  setFilter: any;
}

export const CaseSensitiveButton = ({ actualFilterValue, filter, setFilter }: Props) => (
  <AvTooltip title={`Case Sensitive ${actualFilterValue.expression!.caseInsensitive ? 'OFF' : 'ON'}`}>
    <AvButton
      variant="outlined"
      value="case_sensitive"
      active={!actualFilterValue.expression!.caseInsensitive}
      onClick={() => setFilter({ ...filter, expression: { ...filter.expression, caseInsensitive: !filter.expression!.caseInsensitive } })}
      sx={{ padding: '5px' }}>
      <CaseSensitive />
    </AvButton>
  </AvTooltip>
);
